import { CtaNote, Reveal, WhatsAppCta } from "@/components/brand";
import { CTA_NOTE } from "@/lib/offer";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

// Ordered by the objections that stall the WhatsApp conversation.
// RASCUNHO: confirmar respostas marcadas antes do deploy.
const faqs = [
  {
    question: "Para quem é a Ambitie?",
    answer:
      "Para empresas que precisam de um site ou sistema à altura do negócio, que passe confiança no primeiro acesso e leve o cliente direto para o contato.",
  },
  {
    question: "Quanto custa?",
    answer:
      "Sites começam em R$ 700 e variam conforme o escopo. Sistemas sob medida partem de R$ 15.000 e são orçados depois de uma conversa. Em todos os casos, o valor é fechado antes de começar.",
  },
  {
    // RASCUNHO
    question: "Tem opção mais simples ou mais específica?",
    answer:
      "Sim. Landing page para uma campanha ou produto, a partir de R$ 700. Site para clínica, com serviços, equipe e agendamento pelo WhatsApp, a partir de R$ 2.000. Se for algo menor, alinhamos o orçamento e fazemos uma oferta especial, dependendo do escopo.",
  },
  {
    // RASCUNHO
    question: "Posso parcelar?",
    answer:
      "Sim. A forma de pagamento é combinada na proposta, antes de começar, junto com escopo e prazo.",
  },
  {
    question: "Quanto tempo leva?",
    answer: "Sites ficam no ar em 7 dias. Sistemas sob medida levam de 2 a 3 meses, conforme a complexidade.",
  },
  {
    question: "Quem vai me atender?",
    answer:
      "Você tem um responsável fixo: o Bruno, fundador da Ambitie. Ele conduz o projeto e coordena a equipe de especialistas envolvida. O contato é direto pelo WhatsApp, do primeiro contato à entrega.",
  },
  {
    // RASCUNHO
    question: "O site fica no meu nome?",
    answer:
      "Sim. Domínio e hospedagem ficam registrados em nome da sua empresa. A gente orienta a contratação e cuida da configuração.",
  },
  {
    // RASCUNHO
    question: "E se eu precisar mudar algo depois?",
    answer:
      "Ajustes combinados no escopo estão incluídos. Mudanças depois da entrega são orçadas na hora, pelo WhatsApp, sem mensalidade obrigatória.",
  },
  {
    question: "Preciso ter conhecimento técnico?",
    answer:
      "Não. Você explica o objetivo do negócio. A parte técnica fica com a gente, e cada etapa é explicada sem jargão.",
  },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 md:py-28">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
        <Reveal className="lg:col-span-4">
          <h2 className="text-3xl font-bold tracking-[-0.03em] text-foreground md:text-5xl">
            Perguntas frequentes
          </h2>
          <p className="mt-4 leading-relaxed text-muted-foreground">
            Sua dúvida não está aqui? Pergunte direto no WhatsApp.
          </p>
          <WhatsAppCta variant="outline" size="md" location="faq" className="mt-6" />
          <CtaNote className="mt-3">{CTA_NOTE}</CtaNote>
        </Reveal>

        <Reveal delay={0.1} className="lg:col-span-8">
          <Accordion type="single" collapsible className="border-t border-border">
            {faqs.map((faq, i) => (
              <AccordionItem key={faq.question} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-trigger-${i}`}
                  className="py-6 text-left text-base font-semibold text-foreground hover:no-underline md:text-lg [&>svg]:text-primary"
                >
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="max-w-[62ch] pb-6 text-base leading-relaxed text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
